import { Component, EventEmitter, inject, OnInit, Output, signal, ViewChild, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BranchDetails } from '../branch-details/branch-details.component';
import { BranchContactDetails } from '../branch-contact-details/branch-contact-details.component';
import { BranchLlyodDetails } from '../branch-llyod-details/branch-llyod-details.component';
import { ActivatedRoute, Router } from '@angular/router';
import { MatTabsModule } from '@angular/material/tabs';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { noWhitespaceValidator } from '../../../../utils/no-whitespace.validator';
import { BranchContactPayload, BranchDetailsResponse, BranchLlyodPayload, BranchRequestPayload } from '../../../../models/SystemAdmin.model';
import { SystemAdminService } from '../../../../services/system-admin.service';
import { AuthService } from '../../../../auth/auth.service';
import { ToastService } from '../../../../services/toast.service';
import { ToastType } from '../../../../enums/config.enum';
import { UnsavedFormChangesGuard } from '../../../../guards/unsaved-form-changes.guard';
import { MatDialog } from '@angular/material/dialog';
import { CountryISO } from 'ngx-intl-tel-input';
import { PhoneNumberUtil, PhoneNumberFormat } from 'google-libphonenumber';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-add-branch',
  standalone: true,
  imports: [CommonModule, MatTabsModule, BranchDetails, BranchContactDetails, BranchLlyodDetails, 
    ReactiveFormsModule],
  templateUrl: './add-branch.component.html',
  styleUrl: './add-branch.component.scss'
})
export class AddBranchComponent implements OnInit, OnDestroy, UnsavedFormChangesGuard{
  
  selectedTab = signal(0);
  companyId = signal<string>('');
  branchTitle = signal<string>('');
  branchId = signal<string>('');
  isCreateBranch = signal<boolean>(true);
  isAdminCompanySelected = signal(false);
  router = inject(Router);
  authService = inject(AuthService);
  activateRoute = inject(ActivatedRoute);
  systemAdminService = inject(SystemAdminService);
  toastService = inject(ToastService);
  fb: FormBuilder = inject(FormBuilder);
  dialog = inject(MatDialog);
  countryId: number | null = null;
  countryIdSignal = signal<string | null>(null);
  countryList = signal<any[]>([]);
  phoneUtil = PhoneNumberUtil.getInstance();
    @Output() countryChange = new EventEmitter<number>();
  branchForm = this.fb.group({
    branchName: ['', [Validators.required, noWhitespaceValidator, Validators.maxLength(128)]],
    branchCode: ['', [Validators.required, noWhitespaceValidator, Validators.pattern('^[a-zA-Z0-9\\s\\-\\.]+$'), Validators.maxLength(64)]],
    branchCompany: [null, [Validators.required, noWhitespaceValidator]],
    unitNum: [null],
    streetNum: [null, [Validators.required, noWhitespaceValidator]],
    streetName: [null,[Validators.required, noWhitespaceValidator, Validators.pattern('^[a-zA-Z0-9\\s\\-\\.]+$'), Validators.maxLength(128)]],
    cityId: [null, [Validators.required, noWhitespaceValidator, Validators.maxLength(64)]],
    countyId: [null, [Validators.required, noWhitespaceValidator, Validators.maxLength(64)]],
    stateId: [null, [Validators.required, noWhitespaceValidator, Validators.maxLength(64)]],
    zipCode: [null, [Validators.required, noWhitespaceValidator, Validators.pattern('^[a-zA-Z0-9\\s\\-\\.]+$')]],
    branchPhone: ['', [Validators.required, noWhitespaceValidator]],
    branchPhoneCountryCode: [CountryISO.UnitedStates, [Validators.required, noWhitespaceValidator]],
    branchEmail: [null, [Validators.required, noWhitespaceValidator, Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)]],
    countryId: [null, [Validators.required, noWhitespaceValidator, Validators.maxLength(64)]],
    BranchCountryCode: [null as string | null],
    countryCode: [null as string | null],
    contactCountryCode: [null as string | null],
    BranchIPhone:[''],
    iPhone:[''],
    contactPersonIPhone:[''],
    branchAddressId: [null],
    isActive: [1],
    isDeleted: [0]
  });
  branchContactForm = this.fb.group({
    contactPersonName: [null, [Validators.required, noWhitespaceValidator, Validators.pattern('^[a-zA-Z0-9\\s\\-\\.]+$'), Validators.maxLength(128)]],
    contactPersonRole: [null, [Validators.required, noWhitespaceValidator, Validators.pattern('^[a-zA-Z0-9\\s\\-\\.]+$'), Validators.maxLength(128)]],
    contactPersonEmail: [null, [Validators.required, noWhitespaceValidator, Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)]],
    contactPersonPhone: ['', [Validators.required, noWhitespaceValidator]],
    contactPersonPhoneCountryCode: [CountryISO.UnitedStates, [Validators.required, noWhitespaceValidator]],
    contactCountryCode: [null as string | null],
    contactPersonIPhone:['']
  });
  branchLlyodForm = this.fb.group({
    lloydsBrokerAssigned: [0, [Validators.required, noWhitespaceValidator]],
    lloydsPIN: [{ value: null, disabled: true }, [Validators.pattern('^[a-zA-Z0-9\\s\\-\\.]+$'), Validators.maxLength(128)]],
    lloydsBrokerLegalName: [{ value: null, disabled: true },  [Validators.pattern('^[a-zA-Z0-9\\s\\-\\.]+$'), Validators.maxLength(128)]],
    unitNum: [{ value: null, disabled: true }],
    streetNum: [{ value: null, disabled: true }],
    streetName: [{ value: null, disabled: true }, [Validators.pattern('^[a-zA-Z0-9\\s\\-\\.]+$'), Validators.maxLength(128)]],
    cityId: [{ value: null, disabled: true }, [Validators.maxLength(64)]],
    countyId: [{ value: null, disabled: true }, [Validators.maxLength(64)]],
    stateId: [{ value: null, disabled: true }, [Validators.maxLength(64)]],
    zipCode: [{ value: null, disabled: true },  [Validators.pattern('^[a-zA-Z0-9\\s\\-\\.]+$')]],
    lloydsBrokerContactName: [{ value: null, disabled: true }, [Validators.pattern('^[a-zA-Z0-9\\s\\-\\.]+$'), Validators.maxLength(128)]],
    lloydsBrokerContactEmail: [{ value: null, disabled: true }, [Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)]],
    countryId: [''],
    lloydsBrokerAddressId: [0]
  });
  initialBranchForm: any;
  intitalBranchContactForm: any;
  initialBranchLlyodForm: any;
  private changesSaved: boolean = false;
  branchPhoneSub: Subscription = new Subscription();
  contactPhoneSub: Subscription = new Subscription();
  
  ngOnInit(): void {
    this.getCountryList();
    this.activateRoute.params.subscribe({
      next: (params) => {
        if(params && params['branchId']){
          this.branchId.set(params['branchId']);
          this.fetchBranchDetails(params['branchId']); // getBranch Details
          this.isCreateBranch.set(false);
          this.branchForm.get('isActive')?.enable();
        }else{
          // addNewCompany form view
          this.branchForm.get('isActive')?.disable();
        }
      }
    });
    // Store the initial form value
    this.initialBranchForm = this.branchForm.getRawValue(); 
    this.intitalBranchContactForm = this.branchContactForm.getRawValue(); 
    this.initialBranchLlyodForm = this.branchLlyodForm.getRawValue();
    
    // Live input formatting subscriptions for branch and contact phones
    const branchPhoneCtrl = this.branchForm.get('branchPhone');
    const contactPhoneCtrl = this.branchContactForm.get('contactPersonPhone');
    
    if (branchPhoneCtrl) {
      this.branchPhoneSub = branchPhoneCtrl.valueChanges.subscribe((value: any) => {
        if (value !== null && value !== undefined) {
          // When separateDialCode is true, ngx-intl-tel-input returns a string (phone number only)
          if (typeof value === 'string') {
            // Format the phone number based on country code
            const countryCode = this.branchForm.get('branchPhoneCountryCode')?.value || CountryISO.UnitedStates;
            // Extract digits directly from input (don't use extractRawPhoneNumber for real-time formatting)
            const digits = value.replace(/\D/g, '');
            const maxLength = this.getMaxPhoneLength(countryCode);
            
            // If digits exceed max length, truncate IMMEDIATELY to prevent excessive input
            if (digits.length > maxLength) {
              const truncated = digits.substring(0, maxLength);
              const truncatedFormatted = this.formatPhoneNumber(truncated, countryCode);
              branchPhoneCtrl.setValue(truncatedFormatted || truncated, { emitEvent: false });
              branchPhoneCtrl.updateValueAndValidity({ emitEvent: false });
              return;
            }
            
            // Format the raw digits directly (consistent extraction for real-time formatting)
            // Don't use extractRawPhoneNumber here as it's meant for already-formatted numbers
            const formatted = this.formatPhoneNumber(digits, countryCode);
            
            // For UK, ALWAYS apply formatting to ensure consistency
            // Use a more aggressive approach to override component's internal formatting
            if (formatted) {
              if (countryCode === CountryISO.UnitedKingdom) {
                // Store the expected formatted value
                const expectedFormatted = formatted;
                
                // Apply formatting immediately
                branchPhoneCtrl.setValue(expectedFormatted, { emitEvent: false });
                
                // Use multiple timing strategies to ensure formatting sticks
                // Strategy 1: requestAnimationFrame (next frame)
                requestAnimationFrame(() => {
                  const currentValue = branchPhoneCtrl.value;
                  if (currentValue && typeof currentValue === 'string') {
                    const currentDigits = currentValue.replace(/\D/g, '');
                    if (currentDigits === digits && currentValue !== expectedFormatted) {
                      branchPhoneCtrl.setValue(expectedFormatted, { emitEvent: false });
                    }
                  }
                });
                
                // Strategy 2: setTimeout with short delay
                setTimeout(() => {
                  const currentValue = branchPhoneCtrl.value;
                  if (currentValue && typeof currentValue === 'string') {
                    const currentDigits = currentValue.replace(/\D/g, '');
                    if (currentDigits === digits && currentValue !== expectedFormatted) {
                      branchPhoneCtrl.setValue(expectedFormatted, { emitEvent: false });
                    }
                  }
                }, 50);
                
                // Strategy 3: setTimeout with longer delay as final fallback
                setTimeout(() => {
                  const currentValue = branchPhoneCtrl.value;
                  if (currentValue && typeof currentValue === 'string') {
                    const currentDigits = currentValue.replace(/\D/g, '');
                    if (currentDigits === digits && currentValue !== expectedFormatted) {
                      branchPhoneCtrl.setValue(expectedFormatted, { emitEvent: false });
                    }
                  }
                }, 200);
              } else if (formatted !== value) {
                branchPhoneCtrl.setValue(formatted, { emitEvent: false });
              }
            }
          } else if (value && typeof value === 'object' && value.number !== undefined) {
            // Handle object format (for backward compatibility)
            const countryCode = value.countryCode || this.branchForm.get('branchPhoneCountryCode')?.value || CountryISO.UnitedStates;
            if (value.countryCode) {
              this.branchForm.get('branchPhoneCountryCode')?.setValue(value.countryCode, { emitEvent: false });
            }
            // Convert to string format for separateDialCode mode
            const rawNumber = this.extractRawPhoneNumber(value.number, countryCode);
            const formatted = this.formatPhoneNumber(rawNumber, countryCode);
            branchPhoneCtrl.setValue(formatted || '', { emitEvent: false });
          }
        }
      });
    }
    
    if (contactPhoneCtrl) {
      this.contactPhoneSub = contactPhoneCtrl.valueChanges.subscribe((value: any) => {
        if (value !== null && value !== undefined) {
          // When separateDialCode is true, ngx-intl-tel-input returns a string (phone number only)
          if (typeof value === 'string') {
            // Format the phone number based on country code
            const countryCode = this.branchContactForm.get('contactPersonPhoneCountryCode')?.value || CountryISO.UnitedStates;
            // Extract digits directly from input (don't use extractRawPhoneNumber for real-time formatting)
            const digits = value.replace(/\D/g, '');
            const maxLength = this.getMaxPhoneLength(countryCode);
            
            // If digits exceed max length, truncate IMMEDIATELY to prevent excessive input
            if (digits.length > maxLength) {
              const truncated = digits.substring(0, maxLength);
              const truncatedFormatted = this.formatPhoneNumber(truncated, countryCode);
              contactPhoneCtrl.setValue(truncatedFormatted || truncated, { emitEvent: false });
              contactPhoneCtrl.updateValueAndValidity({ emitEvent: false });
              return;
            }
            
            // Format the raw digits directly (consistent extraction for real-time formatting)
            // Don't use extractRawPhoneNumber here as it's meant for already-formatted numbers
            const formatted = this.formatPhoneNumber(digits, countryCode);
            
            // For UK, ALWAYS apply formatting to ensure consistency
            // Use a more aggressive approach to override component's internal formatting
            if (formatted) {
              if (countryCode === CountryISO.UnitedKingdom) {
                // Store the expected formatted value
                const expectedFormatted = formatted;
                
                // Apply formatting immediately
                contactPhoneCtrl.setValue(expectedFormatted, { emitEvent: false });
                
                // Use multiple timing strategies to ensure formatting sticks
                // Strategy 1: requestAnimationFrame (next frame)
                requestAnimationFrame(() => {
                  const currentValue = contactPhoneCtrl.value;
                  if (currentValue && typeof currentValue === 'string') {
                    const currentDigits = currentValue.replace(/\D/g, '');
                    if (currentDigits === digits && currentValue !== expectedFormatted) {
                      contactPhoneCtrl.setValue(expectedFormatted, { emitEvent: false });
                    }
                  }
                });
                
                // Strategy 2: setTimeout with short delay
                setTimeout(() => {
                  const currentValue = contactPhoneCtrl.value;
                  if (currentValue && typeof currentValue === 'string') {
                    const currentDigits = currentValue.replace(/\D/g, '');
                    if (currentDigits === digits && currentValue !== expectedFormatted) {
                      contactPhoneCtrl.setValue(expectedFormatted, { emitEvent: false });
                    }
                  }
                }, 50);
                
                // Strategy 3: setTimeout with longer delay as final fallback
                setTimeout(() => {
                  const currentValue = contactPhoneCtrl.value;
                  if (currentValue && typeof currentValue === 'string') {
                    const currentDigits = currentValue.replace(/\D/g, '');
                    if (currentDigits === digits && currentValue !== expectedFormatted) {
                      contactPhoneCtrl.setValue(expectedFormatted, { emitEvent: false });
                    }
                  }
                }, 200);
              } else if (formatted !== value) {
                contactPhoneCtrl.setValue(formatted, { emitEvent: false });
              }
            }
          } else if (value && typeof value === 'object' && value.number !== undefined) {
            // Handle object format (for backward compatibility)
            const countryCode = value.countryCode || this.branchContactForm.get('contactPersonPhoneCountryCode')?.value || CountryISO.UnitedStates;
            if (value.countryCode) {
              this.branchContactForm.get('contactPersonPhoneCountryCode')?.setValue(value.countryCode, { emitEvent: false });
            }
            // Convert to string format for separateDialCode mode
            const rawNumber = this.extractRawPhoneNumber(value.number, countryCode);
            const formatted = this.formatPhoneNumber(rawNumber, countryCode);
            contactPhoneCtrl.setValue(formatted || '', { emitEvent: false });
          }
        }
      });
    }
    
    // Subscribe to country code changes to reformat phone numbers
    const branchPhoneCountryCodeCtrl = this.branchForm.get('branchPhoneCountryCode');
    const contactPersonPhoneCountryCodeCtrl = this.branchContactForm.get('contactPersonPhoneCountryCode');
    
    if (branchPhoneCountryCodeCtrl) {
      branchPhoneCountryCodeCtrl.valueChanges.subscribe((countryCode: CountryISO | null) => {
        if (countryCode) {
          // Reset phone number field when country code changes
          branchPhoneCtrl?.setValue('', { emitEvent: false });
        }
      });
    }
    
    if (contactPersonPhoneCountryCodeCtrl) {
      contactPersonPhoneCountryCodeCtrl.valueChanges.subscribe((countryCode: CountryISO | null) => {
        if (countryCode) {
          // Reset phone number field when country code changes
          contactPhoneCtrl?.setValue('', { emitEvent: false });
        }
      });
    }
  }
  
  ngOnDestroy(): void {
    this.branchPhoneSub.unsubscribe();
    this.contactPhoneSub.unsubscribe();
  }

  getCountryList() {
    this.systemAdminService.getCountryList().subscribe({
      next: (response: any) => {
        if(response){
          this.countryList.set(response);
          // If countryId is already set, update countryCode
          const currentCountryId = this.branchForm.get('countryId')?.value;
          if (currentCountryId) {
            this.updateCountryCode(typeof currentCountryId === 'string' ? Number(currentCountryId) : currentCountryId);
          }
        }
      },
      error: (error: any) => {
        console.log("error", error);
        this.toastService.addNotification({message: 'System error. Failed to retrieve data. Please exit and contact help@AbacusAU.com.', type: ToastType.Error});
      }
    })
  }

  private updateCountryCode(countryId: number) {
    const selectedCountry = this.countryList().find(c => Number(c.countryId) === Number(countryId));
    const countryCode = selectedCountry?.isdCode ? String(selectedCountry.isdCode) : null;
    this.branchForm.get('BranchCountryCode')?.setValue(countryCode);
    this.branchForm.get('countryCode')?.setValue(countryCode);
    this.branchForm.get('contactCountryCode')?.setValue(countryCode);
    
    // Note: Phone country codes should NOT be updated when country dropdown changes
    // Only zipcode, state, city, and county should be reset (handled in branch-details component)
  }

  fetchBranchDetails(branchId: string) {
    this.systemAdminService.getBranchDetails(branchId).subscribe({
      next: (response: BranchDetailsResponse) => {
        if(response){
          this.branchTitle.set(response?.branchName);
          // this.onBindFormData(response);
        }
      },
      error: (error: any) => {
        console.log("error", error);
        this.toastService.addNotification({message: 'System error. Failed to retrieve data. Please exit and contact help@AbacusAU.com.', type: ToastType.Error});
      }
    });
  };

  onAdminCompanySelected(isAdmin: boolean) {
    this.isAdminCompanySelected.set(isAdmin);    
}

onCountryChange(selectedCountryId: number | string) {
  // Convert to number if it's a string
  const countryIdNum = typeof selectedCountryId === 'string' ? Number(selectedCountryId) : selectedCountryId;
  this.countryId = countryIdNum; // Store the selected country ID
  
  // Set countryCode in form based on selected country
  if (this.countryList().length > 0) {
    this.updateCountryCode(countryIdNum);
  } else {
    // If countryList is not loaded yet, wait for it
    setTimeout(() => {
      this.updateCountryCode(countryIdNum);
    }, 100);
  }
  
  this.formatPhoneNumberInputs(); // Call the method to format phone numbers
}

onCountryIdChange(countryId: string | null) {
  this.countryIdSignal.set(countryId);
  
  // Update contactCountryCode when countryId changes for contact form
  if (countryId && this.countryList().length > 0) {
    const selectedCountry = this.countryList().find(c => Number(c.countryId) === Number(countryId));
    const countryCode = selectedCountry?.isdCode ? String(selectedCountry.isdCode) : null;
    this.branchContactForm.get('contactCountryCode')?.setValue(countryCode);
    
    // Update contact person phone country code
    const contactPhoneCountryCodeISO = countryCode ? this.mapCallingCodeToISO(countryCode) : null;
    if (contactPhoneCountryCodeISO) {
      this.branchContactForm.get('contactPersonPhoneCountryCode')?.setValue(contactPhoneCountryCodeISO);
    }
  }
}


formatPhoneNumberInputs() {

let corporatePhoneValue = this.branchForm.get('branchPhone')?.value ?? null;
let contactPersonPhoneValue = this.branchContactForm.get('contactPersonPhone')?.value ?? null;

// Ensure they are strings before formatting
corporatePhoneValue = corporatePhoneValue !== null ? String(corporatePhoneValue) : null;
contactPersonPhoneValue = contactPersonPhoneValue !== null ? String(contactPersonPhoneValue) : null;

// Remove any existing country code prefix from all countries
let corporateRaw = corporatePhoneValue ? corporatePhoneValue.replace(/\D/g, '') : null;
let contactRaw = contactPersonPhoneValue ? contactPersonPhoneValue.replace(/\D/g, '') : null;

// Remove country code prefixes if present (check all countries in list)
if (corporateRaw && this.countryList().length > 0) {
  for (const country of this.countryList()) {
    const prefixDigits = String(country.isdCode || '').replace(/\D/g, '');
    if (prefixDigits && corporateRaw.startsWith(prefixDigits)) {
      corporateRaw = corporateRaw.substring(prefixDigits.length);
      break;
    }
  }
}

if (contactRaw && this.countryList().length > 0) {
  for (const country of this.countryList()) {
    const prefixDigits = String(country.isdCode || '').replace(/\D/g, '');
    if (prefixDigits && contactRaw.startsWith(prefixDigits)) {
      contactRaw = contactRaw.substring(prefixDigits.length);
      break;
    }
  }
}

// Format with new country code prefix
this.branchForm.get('branchPhone')?.setValue(this.formatPhoneNumber(corporateRaw));
this.branchContactForm.get('contactPersonPhone')?.setValue(this.formatContactPhoneNumber(contactRaw));
}

formatContactPhoneNumber(phoneNumber: string | number | null | undefined): string | null {
  // Convert number to string
  if (typeof phoneNumber === "number") {
    phoneNumber = phoneNumber.toString();
  }

  // If phoneNumber is still invalid, return null
  if (!phoneNumber || typeof phoneNumber !== "string") {
    return null;
  }

  const countryId = this.countryIdSignal() ? Number(this.countryIdSignal()) : null;

  // Get country code prefix from form
  const countryCodePrefix = this.branchContactForm.get('contactCountryCode')?.value ?? null;
  const countryCode = countryCodePrefix ? String(countryCodePrefix) : '';

  // Remove country code prefix if already present
  let cleanedNumber = phoneNumber.replace(/\D/g, ''); // Remove non-numeric characters
  if (countryCode) {
    const prefixDigits = countryCode.replace(/\D/g, '');
    if (prefixDigits && cleanedNumber.startsWith(prefixDigits)) {
      cleanedNumber = cleanedNumber.substring(prefixDigits.length);
    }
  }

  // If the number has fewer digits than required for a valid format, return with prefix if available
  if ((countryId == 1 && cleanedNumber.length < 10) || (countryId == 2 && cleanedNumber.length < 11)) {
    return countryCode ? `${countryCode} ${cleanedNumber}` : cleanedNumber;
  }

  // Format for USA (countryId 1) - +1 (XXX) XXX-XXXX
  if (countryId == 1 && cleanedNumber.length === 10) {
    const match = cleanedNumber.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return countryCode ? `${countryCode} (${match[1]}) ${match[2]}-${match[3]}` : `(${match[1]}) ${match[2]}-${match[3]}`;
    }
  } 
  // Format for UK (countryId 2) - +44 XXX XXX XXXX
  else if (countryId == 2 && cleanedNumber.length === 11) {
    const match = cleanedNumber.match(/^(\d{3})(\d{4})(\d{4})$/);
    if (match) {
      return countryCode ? `${countryCode} ${match[1]} ${match[2]} ${match[3]}` : `${match[1]} ${match[2]} ${match[3]}`;
    }
  }

  // Return original with prefix if available
  return countryCode ? `${countryCode} ${phoneNumber}` : phoneNumber; 
}



  onBindFormData(formValue: any) {
    this.branchForm.patchValue({
      branchName: formValue.branchName,
      branchCode: formValue.branchCode,
      branchCompany: formValue.companyId,
      branchEmail: formValue.branchEmail,
      isActive: formValue.isActive,
      isDeleted: formValue.isDeleted,
      branchAddressId: formValue.branchAddressId,
      unitNum: formValue.branchAddress?.unitNum,
      streetNum: formValue.branchAddress?.streetNum,
      streetName: formValue.branchAddress?.streetName,
      stateId: formValue.branchAddress?.stateId,
      countyId: formValue.branchAddress?.countyId,
      cityId: formValue.branchAddress?.cityId,
      zipCode: formValue.branchAddress?.zipCode,
      countryId: formValue.branchAddress?.countryId,
    });
    
    // Get phone numbers and convert to string if they're numbers
    const branchPhone = formValue?.branchPhone ?? formValue?.iPhone?.replace(/^\+\d+/, '') ?? formValue?.branchIPhone?.replace(/^\+\d+/, '') ?? null;
    const countryId = formValue.branchAddress?.countryId ?? null;
    
    // Get ISO2 code from API response (prioritize this over calling codes)
    // Check both uppercase and lowercase property names for compatibility
    const branchPhoneCodeFromResponse = formValue?.BranchPhoneCode ?? formValue?.branchPhoneCode ?? null;
    
    // Get country codes from response - check all three fields and use whichever has a value
    const BranchCountryCodeFromResponse = formValue?.BranchCountryCode ?? formValue?.branchCountryCode ?? null;
    const countryCodeFromResponse = formValue?.countryCode ?? null;
    const contactCountryCodeFromResponse = formValue?.contactCountryCode ?? null;
    
    // Check if phone codes are missing (for existing records)
    const phoneCodesMissing = !branchPhoneCodeFromResponse && !BranchCountryCodeFromResponse && 
                              !countryCodeFromResponse && !contactCountryCodeFromResponse;
    
    // Convert ISO2 code to CountryISO enum (if provided)
    // IMPORTANT: Use ISO2 codes directly from API response to avoid ambiguity
    let branchPhoneCodeISO: CountryISO | null = null;
    
    if (branchPhoneCodeFromResponse) {
      const iso2Upper = String(branchPhoneCodeFromResponse).toUpperCase().trim();
      // Directly use the ISO2 code as CountryISO (CountryISO enum values are ISO2 codes)
      if (iso2Upper && iso2Upper.length === 2) {
        branchPhoneCodeISO = iso2Upper as CountryISO;
      }
    }
    
    // If phone codes are missing and we have countryId, use it to determine phone country code
    if (phoneCodesMissing && countryId) {
      const countryCodeFromCountryId = this.getCountryCodeFromCountryId(countryId);
      if (countryCodeFromCountryId) {
        // Use countryId to set phone code
        branchPhoneCodeISO = countryCodeFromCountryId;
      }
    }
    
    // Use the first available country code (priority: BranchCountryCode > countryCode > contactCountryCode)
    const branchPhoneCountryCodeValue = BranchCountryCodeFromResponse || countryCodeFromResponse || contactCountryCodeFromResponse;
    
    // Convert calling codes to CountryISO for phone dropdowns
    const branchPhoneCountryCodeISOFromCallingCode = branchPhoneCountryCodeValue 
      ? this.mapCallingCodeToISO(String(branchPhoneCountryCodeValue))
      : null;
    
    const branchPhoneCountryCode = branchPhoneCodeISO ?? 
      branchPhoneCountryCodeISOFromCallingCode ?? 
      (this.getCountryCodeFromCountryId(countryId) || CountryISO.UnitedStates);
    
    // Set phone country code FIRST (before formatting phone numbers)
    // CRITICAL: If ISO2 code is available from API response or countryId, use it directly
    if (branchPhoneCodeISO) {
      // Use ISO2 code directly from API response or countryId (e.g., "GB" for UK)
      this.branchForm.get('branchPhoneCountryCode')?.setValue(branchPhoneCodeISO, { emitEvent: false });
    } else {
      // Fallback to calling code conversion only if ISO2 is not available
      this.branchForm.get('branchPhoneCountryCode')?.setValue(branchPhoneCountryCode, { emitEvent: false });
    }
    
    // Ensure the ISO2 code is set after a brief delay to allow ngx-intl-tel-input to initialize
    if (branchPhoneCodeISO) {
      setTimeout(() => {
        this.branchForm.get('branchPhoneCountryCode')?.setValue(branchPhoneCodeISO, { emitEvent: false });
      }, 100);
    }
    
    // Set country codes in form - use the first available value
    if (BranchCountryCodeFromResponse) {
      this.branchForm.get('BranchCountryCode')?.setValue(String(BranchCountryCodeFromResponse));
      this.branchForm.get('countryCode')?.setValue(String(BranchCountryCodeFromResponse));
    } else if (countryCodeFromResponse) {
      this.branchForm.get('BranchCountryCode')?.setValue(String(countryCodeFromResponse));
      this.branchForm.get('countryCode')?.setValue(String(countryCodeFromResponse));
    } else if (contactCountryCodeFromResponse) {
      this.branchForm.get('BranchCountryCode')?.setValue(String(contactCountryCodeFromResponse));
      this.branchForm.get('countryCode')?.setValue(String(contactCountryCodeFromResponse));
    }
    
    if (contactCountryCodeFromResponse) {
      this.branchForm.get('contactCountryCode')?.setValue(String(contactCountryCodeFromResponse));
    } else if (branchPhoneCountryCodeValue) {
      // If contactCountryCode is not in response, use the branch phone country code as fallback
      this.branchForm.get('contactCountryCode')?.setValue(String(branchPhoneCountryCodeValue));
    }
    
    // Format phone number AFTER country code is set
    setTimeout(() => {
      if (branchPhone !== null) {
        const formattedPhone = this.formatPhoneNumberForBinding(String(branchPhone), branchPhoneCountryCode);
        this.branchForm.get('branchPhone')?.setValue(formattedPhone);
      }
    }, 0);
  }
  
  formatPhoneNumber(phoneNumber: string | number | null | undefined, countryCode?: CountryISO | null): string | null {
    // Convert number to string
    if (typeof phoneNumber === "number") {
      phoneNumber = phoneNumber.toString();
    }

    // If phoneNumber is still invalid, return null
    if (!phoneNumber || typeof phoneNumber !== "string") {
      return null;
    }

    // Use provided countryCode or default to address country
    const selectedCountryCode = countryCode || this.getCountryCodeFromCountryId(this.countryId);
    
    if (!selectedCountryCode) {
      return phoneNumber;
    }

  try {
    // Remove all non-digit characters for parsing
    const cleanedNumber = phoneNumber.replace(/\D/g, '');
    
    // Special handling for UK to ensure consistent formatting - ALWAYS use this for UK
    if (selectedCountryCode === CountryISO.UnitedKingdom) {
      // UK numbers: 10 digits (mobile) or 11 digits (landline)
      if (cleanedNumber.length <= 4) {
        return cleanedNumber;
      } else if (cleanedNumber.length <= 7) {
        return `${cleanedNumber.slice(0, 4)} ${cleanedNumber.slice(4)}`;
      } else if (cleanedNumber.length === 10) {
        // 10 digits: XXXX XXXXXX (e.g., 7655 677666)
        return `${cleanedNumber.slice(0, 4)} ${cleanedNumber.slice(4)}`;
      } else if (cleanedNumber.length === 11) {
        // 11 digits: XXXX XXX XXXX (e.g., 7655 677 6666)
        return `${cleanedNumber.slice(0, 4)} ${cleanedNumber.slice(4, 7)} ${cleanedNumber.slice(7, 11)}`;
      } else {
        // More than 11 digits: truncate to 11 and format
        const truncated = cleanedNumber.substring(0, 11);
        return `${truncated.slice(0, 4)} ${truncated.slice(4, 7)} ${truncated.slice(7, 11)}`;
      }
    }
    
    // Convert CountryISO to lowercase string region code for phoneUtil.parse()
    const regionCode = String(selectedCountryCode).toLowerCase();
    
    // Parse the phone number with the selected country code
    const parsedNumber = this.phoneUtil.parse(cleanedNumber, regionCode);
    
    // Format as national number (without country code) since country code is displayed separately
    try {
      const formatted = this.phoneUtil.format(parsedNumber, PhoneNumberFormat.NATIONAL);
      
      // Remove any leading country code that might be included
      let finalFormatted = formatted.replace(/^\+\d+\s*/, '').trim();
      // Remove leading "0" that NATIONAL format adds for some countries (e.g., Afghanistan, UK)
      // Since country code is displayed separately, we don't need this leading "0"
      finalFormatted = finalFormatted.replace(/^0+/, '').trim();
      return finalFormatted;
    } catch (formatError) {
      const progressiveResult = this.formatPhoneNumberProgressive(cleanedNumber, selectedCountryCode);
      return progressiveResult;
    }
  } catch (error) {
    const fallbackResult = this.formatPhoneNumberFallback(phoneNumber, selectedCountryCode);
    return fallbackResult;
  }
  }
  
  private formatPhoneNumberProgressive(cleanedNumber: string, countryCode: CountryISO | null | undefined): string {
    if (!countryCode || !cleanedNumber) {
      return cleanedNumber;
    }
    
    // Format progressively based on country
    if (countryCode === CountryISO.UnitedStates) {
      // US format: (XXX) XXX-XXXX
      if (cleanedNumber.length <= 3) {
        return cleanedNumber.length > 0 ? `(${cleanedNumber}` : '';
      } else if (cleanedNumber.length <= 6) {
        return `(${cleanedNumber.slice(0, 3)}) ${cleanedNumber.slice(3)}`;
      } else {
        return `(${cleanedNumber.slice(0, 3)}) ${cleanedNumber.slice(3, 6)}-${cleanedNumber.slice(6, 10)}`;
      }
    } else if (countryCode === CountryISO.UnitedKingdom) {
      // UK format: XXXX XXX XXXX or variations
      if (cleanedNumber.length <= 4) {
        return cleanedNumber;
      } else if (cleanedNumber.length <= 7) {
        return `${cleanedNumber.slice(0, 4)} ${cleanedNumber.slice(4)}`;
      } else {
        return `${cleanedNumber.slice(0, 4)} ${cleanedNumber.slice(4, 7)} ${cleanedNumber.slice(7, 11)}`;
      }
    }
    
    // Default: return as is
    return cleanedNumber;
  }
  
  private formatPhoneNumberFallback(phoneNumber: string, countryCode: CountryISO | null | undefined): string {
    if (!countryCode) {
      return phoneNumber;
    }
    
    const cleanedNumber = phoneNumber.replace(/\D/g, '');
    
    // Get country code prefix
    const countryCodePrefix = this.getCountryCodePrefix(countryCode);

    // Remove country code prefix if already present
    let digits = cleanedNumber;
    if (countryCodePrefix) {
      const prefixDigits = countryCodePrefix.replace(/\D/g, '');
      if (digits.startsWith(prefixDigits)) {
        digits = digits.substring(prefixDigits.length);
      }
    }

    // Format based on country (without country code prefix since it's displayed separately)
    if (countryCode === CountryISO.UnitedStates && digits.length === 10) {
      const match = digits.match(/^(\d{3})(\d{3})(\d{4})$/);
      if (match) {
        return `(${match[1]}) ${match[2]}-${match[3]}`;
      }
    } else if (countryCode === CountryISO.UnitedStates && digits.length > 0) {
      // Progressive formatting for US
      return this.formatPhoneNumberProgressive(digits, countryCode);
    } else if (countryCode === CountryISO.UnitedKingdom && digits.length >= 10) {
      // UK numbers can vary, try common format
      if (digits.length === 11) {
        const match = digits.match(/^(\d{4})(\d{3})(\d{4})$/);
        if (match) {
          return `${match[1]} ${match[2]} ${match[3]}`;
        }
      }
      // Progressive formatting for UK
      return this.formatPhoneNumberProgressive(digits, countryCode);
    }

    return digits;
  }
  
  private formatPhoneNumberGeneric(cleanedNumber: string, countryCode: CountryISO | null | undefined): string {
    if (!cleanedNumber) {
      return cleanedNumber;
    }
    
    // Apply generic formatting based on number length
    const length = cleanedNumber.length;
    let result: string;
    
    if (length <= 3) {
      result = cleanedNumber;
    } else if (length <= 6) {
      // Format as XXX XXX
      result = `${cleanedNumber.slice(0, 3)} ${cleanedNumber.slice(3)}`;
    } else if (length <= 9) {
      // Format as XXX XXX XXX
      result = `${cleanedNumber.slice(0, 3)} ${cleanedNumber.slice(3, 6)} ${cleanedNumber.slice(6)}`;
    } else if (length === 10) {
      // Special case for 10-digit numbers: XXX XXX XXXX
      result = `${cleanedNumber.slice(0, 3)} ${cleanedNumber.slice(3, 6)} ${cleanedNumber.slice(6)}`;
    } else if (length <= 12) {
      // Format as XXX XXX XXX XXX
      result = `${cleanedNumber.slice(0, 3)} ${cleanedNumber.slice(3, 6)} ${cleanedNumber.slice(6, 9)} ${cleanedNumber.slice(9)}`;
    } else {
      // For very long numbers, format in groups of 3-4 digits
      let formatted = '';
      let index = 0;
      while (index < length) {
        if (formatted) formatted += ' ';
        const groupSize = (length - index) > 4 ? 4 : (length - index);
        formatted += cleanedNumber.slice(index, index + groupSize);
        index += groupSize;
      }
      result = formatted;
    }
    
    return result;
  }
  
  private getCountryCodePrefix(countryCode: CountryISO | null | undefined): string {
    if (!countryCode) {
      return '';
    }
    try {
      // Convert CountryISO to lowercase string region code for phoneUtil.getCountryCodeForRegion()
      const regionCode = String(countryCode).toLowerCase();
      const callingCode = this.phoneUtil.getCountryCodeForRegion(regionCode);
      return callingCode ? `+${callingCode}` : '';
    } catch {
      return '';
    }
  }
  
  private getCountryCodeFromCountryId(countryId: number | null): CountryISO | null {
    if (!countryId) return null;
    if (countryId === 1) return CountryISO.UnitedStates;
    if (countryId === 2) return CountryISO.UnitedKingdom;
    return null;
  }
  
  // Convert calling code string (e.g., "+93") to CountryISO
  mapCallingCodeToISO(callingCode: string | number | null): CountryISO | null {
    if (!callingCode) return null;
    
    const codeStr = String(callingCode).replace(/^\+/, '');
    const codeNum = parseInt(codeStr, 10);
    
    if (isNaN(codeNum)) return null;
    
    try {
      const supportedRegions = this.phoneUtil.getSupportedRegions();
      for (const region of supportedRegions) {
        try {
          const regionCallingCode = this.phoneUtil.getCountryCodeForRegion(region);
          if (regionCallingCode === codeNum) {
            return region as CountryISO;
          }
        } catch {
          // Skip invalid regions
        }
      }
    } catch {
      // Fallback mappings
    }
    
    if (codeNum === 1) return CountryISO.UnitedStates;
    if (codeNum === 44) return CountryISO.UnitedKingdom;
    if (codeNum === 93) return CountryISO.Afghanistan;
    
    return null;
  }
  
  // Get country calling code from CountryISO (e.g., CountryISO.Afghanistan -> "+93")
  getCountryCallingCode(countryCode: CountryISO | null | undefined): string | null {
    if (!countryCode) {
      return null;
    }
    try {
      const callingCode = this.phoneUtil.getCountryCodeForRegion(countryCode);
      return callingCode ? `+${callingCode}` : null;
    } catch {
      return null;
    }
  }
  
  private formatPhoneNumberForBinding(phoneNumber: string | null, countryCode: CountryISO | null): string | null {
    if (!phoneNumber || typeof phoneNumber !== "string") {
      return null;
    }
    
    // Extract raw digits first - remove all non-digit characters
    let raw = phoneNumber.replace(/\D/g, '');
    
    // Special handling for UK: if 11 digits, cut the last digit (UK numbers should be 10 digits for mobile or 11 with leading 0)
    if (countryCode === CountryISO.UnitedKingdom && raw && raw.length === 11 && !raw.startsWith('0')) {
      raw = raw.substring(0, 10);
    }
    
    // Format the phone number directly - formatPhoneNumber will handle parsing and formatting
    // It will extract raw digits and format according to the country code
    return this.formatPhoneNumber(raw, countryCode);
  }

  private formatPhoneNumberWithCountryCode(phoneNumber: string | null, countryCode: string | null, countryId: number | null): string | null {
    if (!phoneNumber || typeof phoneNumber !== "string") {
      return null;
    }

    // Use countryCode from form if available, otherwise try to get from countryList
    let countryCodePrefix = countryCode ? String(countryCode) : '';
    if (!countryCodePrefix && countryId && this.countryList().length > 0) {
      const selectedCountry = this.countryList().find(c => Number(c.countryId) === Number(countryId));
      countryCodePrefix = selectedCountry?.isdCode ? String(selectedCountry.isdCode) : '';
    }

    // Remove country code prefix if already present
    let cleanedNumber = phoneNumber.replace(/\D/g, ''); // Remove non-numeric characters
    if (countryCodePrefix) {
      const prefixDigits = countryCodePrefix.replace(/\D/g, '');
      if (prefixDigits && cleanedNumber.startsWith(prefixDigits)) {
        cleanedNumber = cleanedNumber.substring(prefixDigits.length);
      }
    }

    // If the number has fewer digits than required for a valid format, return with prefix if available
    if ((countryId == 1 && cleanedNumber.length < 10) || (countryId == 2 && cleanedNumber.length < 11)) {
      return countryCodePrefix ? `${countryCodePrefix} ${cleanedNumber}` : cleanedNumber;
    }

    // Format for USA (countryId 1) - +1 (XXX) XXX-XXXX
    if (countryId == 1 && cleanedNumber.length === 10) {
      const match = cleanedNumber.match(/^(\d{3})(\d{3})(\d{4})$/);
      if (match) {
        return countryCodePrefix ? `${countryCodePrefix} (${match[1]}) ${match[2]}-${match[3]}` : `(${match[1]}) ${match[2]}-${match[3]}`;
      }
    } 
    // Format for UK (countryId 2) - +44 XXX XXX XXXX
    else if (countryId == 2 && cleanedNumber.length === 11) {
      const match = cleanedNumber.match(/^(\d{3})(\d{4})(\d{4})$/);
      if (match) {
        return countryCodePrefix ? `${countryCodePrefix} ${match[1]} ${match[2]} ${match[3]}` : `${match[1]} ${match[2]} ${match[3]}`;
      }
    }

    // Return original with prefix if available
    return countryCodePrefix ? `${countryCodePrefix} ${phoneNumber}` : phoneNumber; 
  }

  onTabChange(index: number): void {
    this.selectedTab.set(index);
  };

  // Method to check if only required fields are valid
  isRequiredFieldsValid(): boolean {
    return (
      this.branchForm.get('branchLegalName')?.hasError('required') === false &&
      this.branchForm.get('branchCode')?.hasError('required') === false &&
      this.branchForm.get('branchCompany')?.hasError('required') === false
    );
  }

  addNewBranchDetails(payload: BranchRequestPayload) {
     this.systemAdminService.addBranchDetails(payload, this.companyId()).subscribe({
      next: (response: any) => {
        if(response){
          const msg =  response?.message || "Branch added successfully";
          this.toastService.addNotification({message: msg, type: ToastType.Success}); // success notification
          this.router.navigate(['/system-admin-dashboard/branch']);
        }
      },
      error: (error: any) => {
        console.log("error", error);
        this.toastService.addNotification({message: "System error. Failed to save data. Please exit and contact help@AbacusAU.com.", type: ToastType.Error}); // error notification
      }
     });
  }

  updateBranchDetails(payload: BranchRequestPayload) {
    this.systemAdminService.updateBranchDetails(payload, this.branchId()).subscribe({
      next: (response: any) => {
        if(response){
          const msg =  response?.message || "Branch updated successfully";
          this.toastService.addNotification({message: msg, type: ToastType.Success}); // success notification
          this.router.navigate(['/system-admin-dashboard/branch']);
        }
      },
      error: (error: any) => {
        console.log("error", error);
        this.toastService.addNotification({message: "System error. Failed to save data. Please exit and contact help@AbacusAU.com.", type: ToastType.Error}); // error notification
      }
    })
  }

  updateBranchContactDetails(payload: BranchContactPayload) {
    this.systemAdminService.updateBranchContact(payload, this.branchId()).subscribe({
      next: (response: any) => {
        if(response){
          // if response is success prompt success message.
          const msg =  response?.message || "Contact Person Details updated successfully";
          this.toastService.addNotification({message: msg, type: ToastType.Success}); // success notification
          this.router.navigate(['/system-admin-dashboard/branch']);
        }
      },
      error: (error: any) => {
        console.log("error", error);
        this.toastService.addNotification({message: "System error. Failed to save data. Please exit and contact help@AbacusAU.com.", type: ToastType.Error}); // error notification
      }
    })
  }

  updateBranchllyodDetails(payload: BranchLlyodPayload){
    const updatedPayload = payload.lloydsBrokerAssigned === 0 ? {"lloydsBrokerAssigned": payload.lloydsBrokerAssigned} : payload;
    this.systemAdminService.updateBranchllyod(updatedPayload, this.branchId()).subscribe({
      next: (response: any) => {
        if(response){
          // if response is success prompt success message.
          const msg =  response?.message || "Lloyd's details updated successfully";
          this.toastService.addNotification({message: msg, type: ToastType.Success}); // success notification
          this.router.navigate(['/system-admin-dashboard/branch']);
        }
      },
      error: (error: any) => {
        console.log("error", error);
        this.toastService.addNotification({message: "System error. Failed to save data. Please exit and contact help@AbacusAU.com.", type: ToastType.Error}); // error notification
      }
    })
  }

  extractRawPhoneNumber(formattedPhoneNumber: string | null | undefined, countryCode?: CountryISO | null): string | null {
    if (typeof formattedPhoneNumber !== 'string') {
      return null;
    }
    
    // Extract all digits first
    let cleaned = formattedPhoneNumber.replace(/\D/g, '');
    
    if (!cleaned || cleaned.length === 0) {
      return null;
    }
    
    // Use provided countryCode or try to get from form fields
    const branchPhoneCountryCode = this.branchForm.get('branchPhoneCountryCode')?.value;
    const contactPersonPhoneCountryCode = this.branchContactForm.get('contactPersonPhoneCountryCode')?.value;
    const selectedCountryCode = countryCode || branchPhoneCountryCode || contactPersonPhoneCountryCode || this.getCountryCodeFromCountryId(this.countryId);
    
    if (!selectedCountryCode) {
      return cleaned;
    }

    // Try to parse and extract national number
    try {
      const parsedNumber = this.phoneUtil.parse(cleaned, selectedCountryCode);
      
      // Get national number (without country code)
      const nationalNumber = parsedNumber.getNationalNumber();
      if (nationalNumber) {
        return String(nationalNumber);
      }
    } catch (error) {
      // Parsing failed - might be incomplete number, try to remove country code prefix manually
    }
    
    // Fallback: remove country code prefix if present
    const countryCodePrefix = this.getCountryCodePrefix(selectedCountryCode);
    if (countryCodePrefix) {
      const prefixDigits = countryCodePrefix.replace(/\D/g, '');
      // Check if the cleaned number starts with the country code prefix
      if (cleaned.startsWith(prefixDigits)) {
        // Remove the prefix to get national number
        cleaned = cleaned.substring(prefixDigits.length);
        // For UK (44), also remove leading 0 if present (UK national format starts with 0)
        if (selectedCountryCode === CountryISO.UnitedKingdom && cleaned.startsWith('0')) {
          cleaned = cleaned.substring(1);
        }
      }
    }
    
    return cleaned;
  }

  onBranchDetailsSubmit(action: boolean) {
    if(this.branchForm.invalid){
      return;
    }
    this.changesSaved = true;
    if(action) {
       const { branchName, branchCode, branchCompany, unitNum, streetNum, streetName,
        cityId, countyId, stateId, zipCode, branchEmail, countryId, contactPersonIPhone, iPhone, BranchIPhone, isActive, isDeleted} = this.branchForm.getRawValue();
        
        const branchPhoneValue = this.branchForm.get('branchPhone')?.value ?? null;
        const branchPhoneCountryCode = this.branchForm.get('branchPhoneCountryCode')?.value;
        
        // Extract raw phone number
        const branchPhone = branchPhoneValue ? this.extractRawPhoneNumber(branchPhoneValue, branchPhoneCountryCode) : null;
        
        // Get country calling code from selected country code
        const countryCallingCode = branchPhoneCountryCode ? this.getCountryCallingCode(branchPhoneCountryCode) : null;
        
        // Get ISO2 code for BranchPhoneCode
        const BranchPhoneCode = branchPhoneCountryCode ? String(branchPhoneCountryCode) : null;
        
        // Set all three country code fields to the same value
        const BranchCountryCode = countryCallingCode;
        const contactCountryCode = countryCallingCode;
        const countryCode = countryCallingCode;

       const payload: BranchRequestPayload = {
         branchName, branchCode, branchEmail, branchPhone, BranchCountryCode, contactCountryCode, countryCode, BranchPhoneCode, contactPersonIPhone, iPhone, BranchIPhone, isActive: isActive ? 1 : 0, isDeleted, createdUserId: Number(this.authService.getUserDetailsFromStorage()?.createdUserId),
         createdDate: new Date().toISOString(), branchAddress: {
          unitNum, streetNum, streetName, stateId, countyId, cityId, zipCode, countryId, createdUserId: Number(this.authService.getUserDetailsFromStorage()?.createdUserId),
          createdDate: new Date().toISOString()
         }
       } 
       this.companyId.set(String(branchCompany));
       this.isCreateBranch() ? this.addNewBranchDetails(payload) : this.updateBranchDetails(payload);
    }
  }

  onBranchContactDetailsSubmit(action: boolean) {
    this.changesSaved = true;
    if(this.branchContactForm.invalid){
      return;
    }

    if(action){
      const {contactPersonName, contactPersonRole, contactPersonEmail} = this.branchContactForm.getRawValue()

      const contactPersonPhoneValue = this.branchContactForm.get('contactPersonPhone')?.value ?? null;
      const contactPersonPhoneCountryCode = this.branchContactForm.get('contactPersonPhoneCountryCode')?.value;
      
      // Extract raw phone number
      const contactPersonPhone = contactPersonPhoneValue ? this.extractRawPhoneNumber(contactPersonPhoneValue, contactPersonPhoneCountryCode) : null;
      
      // Get country calling code from selected country code
      const contactCountryCode = contactPersonPhoneCountryCode ? this.getCountryCallingCode(contactPersonPhoneCountryCode) : null;
      
      // Get ISO2 code for ContactPhoneCode
      const ContactPhoneCode = contactPersonPhoneCountryCode ? String(contactPersonPhoneCountryCode) : null;

      const payload: BranchContactPayload ={
        contactPersonName, contactPersonRole, contactPersonEmail, contactPersonPhone, contactCountryCode, ContactPhoneCode
      }
      this.updateBranchContactDetails(payload);
    }
  }

  onBranchllyodDetailsSubmit(action: boolean) {
    this.changesSaved = true;
    if(this.branchLlyodForm.invalid){
      return;
    }

    if(action){
      const { lloydsPIN, lloydsBrokerAssigned, lloydsBrokerLegalName, lloydsBrokerContactName, lloydsBrokerContactEmail,
        unitNum, streetNum, streetName, countryId, stateId, cityId, countyId, zipCode, lloydsBrokerAddressId
       } = this.branchLlyodForm.getRawValue();
      const payload: BranchLlyodPayload = {
        lloydsPIN, lloydsBrokerAssigned: Number(lloydsBrokerAssigned), lloydsBrokerLegalName, lloydsBrokerContactName, lloydsBrokerContactEmail, 
        lloydsBrokerAddressId, lloydsBrokerAddress: {unitNum, streetNum, streetName, stateId, countyId, cityId, countryId: countryId, zipCode,
          createdUserId: Number(this.authService.getUserDetailsFromStorage()?.createdUserId), createdDate: new Date().toISOString()}
      }
      this.updateBranchllyodDetails(payload);
    }
  }

  isFormDirty(): boolean {
    const branchForm =  JSON.stringify(this.initialBranchForm) !== JSON.stringify(this.branchForm.getRawValue());
    const branchContactForm =  JSON.stringify(this.intitalBranchContactForm) !== JSON.stringify(this.branchContactForm.getRawValue());
    const branchLlyodForm =  JSON.stringify(this.initialBranchLlyodForm) !== JSON.stringify(this.branchLlyodForm.getRawValue());

    return branchForm || branchContactForm || branchLlyodForm;
  }

  canDeactivate(): boolean {
    return this.changesSaved || !this.isFormDirty();
  }

  getMaxPhoneLength(countryCode: CountryISO | null | undefined): number {
    if (!countryCode) return 15;
    const regionCode = String(countryCode).toLowerCase();
    
    // Comprehensive country-to-max-length mapping
    const countryMaxLengths: { [key: string]: number } = {
      // Very short numbers (4-5 digits)
      'nu': 4,  // Niue
      'tk': 4,  // Tokelau
      'nf': 5,  // Norfolk Island
      
      // Short numbers (6-7 digits)
      'gi': 8,  // Gibraltar
      'va': 8,  // Vatican City
      'sm': 9,  // San Marino
      'mc': 9,  // Monaco
      'li': 9,  // Liechtenstein
      
      // Standard 10-digit numbers (US, Canada, etc.)
      'us': 10, // United States
      'ca': 10, // Canada
      'ru': 10, // Russia
      'kz': 10, // Kazakhstan
      'mx': 10, // Mexico
      'br': 11, // Brazil (can be 10 or 11)
      'in': 10, // India
      'au': 9,  // Australia
      'nz': 9,  // New Zealand
      'za': 9,  // South Africa
      'ar': 10, // Argentina
      'cl': 9,  // Chile
      'co': 10, // Colombia
      'pe': 9,  // Peru
      've': 10, // Venezuela
      'ec': 9,  // Ecuador
      'uy': 8,  // Uruguay
      'py': 9,  // Paraguay
      'bo': 8,  // Bolivia
      'cr': 8,  // Costa Rica
      'pa': 8,  // Panama
      'gt': 8,  // Guatemala
      'hn': 8,  // Honduras
      'ni': 8,  // Nicaragua
      'sv': 8,  // El Salvador
      'do': 10, // Dominican Republic
      'cu': 8,  // Cuba
      'jm': 10, // Jamaica
      'tt': 10, // Trinidad and Tobago
      'bb': 10, // Barbados
      'bs': 10, // Bahamas
      'bz': 7,  // Belize
      'gy': 7,  // Guyana
      'sr': 7,  // Suriname
      'gf': 9,  // French Guiana
      
      // 11-digit numbers (UK, etc.)
      'gb': 11, // United Kingdom
      'ie': 9,  // Ireland
      'nl': 9,  // Netherlands
      'be': 9,  // Belgium
      'lu': 9,  // Luxembourg
      'ch': 9,  // Switzerland
      'at': 10, // Austria
      'de': 11, // Germany
      'dk': 8,  // Denmark
      'se': 9,  // Sweden
      'no': 8,  // Norway
      'fi': 9,  // Finland
      'is': 7,  // Iceland
      'pl': 9,  // Poland
      'cz': 9,  // Czech Republic
      'sk': 9,  // Slovakia
      'hu': 9,  // Hungary
      'ro': 10, // Romania
      'bg': 9,  // Bulgaria
      'gr': 10, // Greece
      'pt': 9,  // Portugal
      'es': 9,  // Spain
      'it': 10, // Italy
      'mt': 8,  // Malta
      'cy': 8,  // Cyprus
      
      // Eastern Europe
      'ua': 9,  // Ukraine
      'by': 9,  // Belarus
      'lt': 8,  // Lithuania
      'lv': 8,  // Latvia
      'ee': 8,  // Estonia
      'md': 8,  // Moldova
      'rs': 9,  // Serbia
      'hr': 9,  // Croatia
      'si': 8,  // Slovenia
      'ba': 8,  // Bosnia and Herzegovina
      'mk': 9,  // North Macedonia
      'al': 9,  // Albania
      'me': 8,  // Montenegro
      'xk': 8,  // Kosovo
      
      // Middle East
      'sa': 9,  // Saudi Arabia
      'ae': 9,  // UAE
      'kw': 8,  // Kuwait
      'qa': 8,  // Qatar
      'bh': 8,  // Bahrain
      'om': 8,  // Oman
      'ye': 9,  // Yemen
      'iq': 10, // Iraq
      'ir': 10, // Iran
      'il': 9,  // Israel
      'jo': 9,  // Jordan
      'lb': 8,  // Lebanon
      'sy': 9,  // Syria
      'ps': 9,  // Palestine
      'tr': 10, // Turkey
      'eg': 10, // Egypt
      'ly': 9,  // Libya
      'tn': 8,  // Tunisia
      'dz': 9,  // Algeria
      'ma': 9,  // Morocco
      'sd': 9,  // Sudan
      'et': 9,  // Ethiopia
      
      // Asia
      'cn': 11, // China
      'jp': 10, // Japan
      'kr': 10, // South Korea
      'tw': 9,  // Taiwan
      'hk': 8,  // Hong Kong
      'mo': 8,  // Macau
      'sg': 8,  // Singapore
      'my': 9,  // Malaysia
      'th': 9,  // Thailand
      'vn': 10, // Vietnam
      'ph': 10, // Philippines
      'id': 9,  // Indonesia
      'mm': 9,  // Myanmar
      'kh': 9,  // Cambodia
      'la': 8,  // Laos
      'bn': 7,  // Brunei
      'bd': 10, // Bangladesh
      'pk': 10, // Pakistan
      'lk': 9,  // Sri Lanka
      'np': 10, // Nepal
      'af': 7,  // Afghanistan
      'uz': 9,  // Uzbekistan
      'tm': 8,  // Turkmenistan
      'tj': 9,  // Tajikistan
      'kg': 9,  // Kyrgyzstan
      'mn': 8,  // Mongolia
      
      // Oceania
      'pg': 8,  // Papua New Guinea
      'fj': 7,  // Fiji
      'nc': 6,  // New Caledonia
      'pf': 6,  // French Polynesia
      'ws': 7,  // Samoa
      'to': 7,  // Tonga
      'vu': 7,  // Vanuatu
      'sb': 7,  // Solomon Islands
      'ki': 5,  // Kiribati
      'tv': 6,  // Tuvalu
      'nr': 7,  // Nauru
      'pw': 7,  // Palau
      'fm': 7,  // Micronesia
      'mh': 7,  // Marshall Islands
      
      // Africa
      'ng': 10, // Nigeria
      'ke': 9,  // Kenya
      'tz': 9,  // Tanzania
      'ug': 9,  // Uganda
      'rw': 9,  // Rwanda
      'gh': 9,  // Ghana
      'ci': 8,  // Côte d'Ivoire
      'sn': 9,  // Senegal
      'ml': 8,  // Mali
      'bf': 8,  // Burkina Faso
      'ne': 8,  // Niger
      'td': 8,  // Chad
      'cm': 9,  // Cameroon
      'ga': 8,  // Gabon
      'cg': 9,  // Republic of the Congo
      'cd': 9,  // DR Congo
      'ao': 9,  // Angola
      'zm': 9,  // Zambia
      'zw': 9,  // Zimbabwe
      'bw': 8,  // Botswana
      'na': 9,  // Namibia
      'mw': 9,  // Malawi
      'mz': 9,  // Mozambique
      'mg': 9,  // Madagascar
      'mu': 8,  // Mauritius
      'sc': 7,  // Seychelles
      'km': 7,  // Comoros
      'dj': 8,  // Djibouti
      'er': 7,  // Eritrea
      'so': 8,  // Somalia
      'ss': 9,  // South Sudan
      
      // Caribbean
      'ht': 8,  // Haiti
      'pr': 10, // Puerto Rico
      'vi': 10, // US Virgin Islands
      'vg': 10, // British Virgin Islands
      'ky': 7,  // Cayman Islands
      'bm': 10, // Bermuda
      'tc': 7,  // Turks and Caicos
      'ai': 7,  // Anguilla
      'ms': 7,  // Montserrat
      'gd': 7,  // Grenada
      'lc': 7,  // Saint Lucia
      'vc': 7,  // Saint Vincent
      'ag': 10,  // Antigua and Barbuda
      'dm': 7,  // Dominica
      'kn': 7,  // Saint Kitts and Nevis
      
      // Other territories
      'fo': 6,  // Faroe Islands
      'gl': 6,  // Greenland
      'sj': 8,  // Svalbard
      'ax': 6,  // Åland Islands
      'gg': 10, // Guernsey
      'je': 10, // Jersey
      'im': 10, // Isle of Man
      'ad': 6,  // Andorra
    };
    
    return countryMaxLengths[regionCode] || 15; // Default to 15 for unknown countries
  }
}
